export type { SwitchProps } from '../../../types/switch';
export { Switch } from './adapters/inbound/Switch';
